import React from "react";

export default function Header({ className = "", children }) {
    return <div className={`header ${className}`}>{children}</div>;
}
